/* @flow */

import type { RootState, LoginCredentials, Action } from '../types'

import { ActionRequiresPropertyError } from '../helpers'

export const STATE_KEY: string = 'loginForm'

export const SET_LOGIN_FORM: string = 'opinary/SET_LOGIN_FORM'

export function setLoginForm(credentials: LoginCredentials): Action {
  return {
    type: SET_LOGIN_FORM,
    credentials,
  }
}

export function selectLoginForm(rootState: RootState): LoginCredentials {
  return rootState[STATE_KEY]
}

export function selectLoginFormErrors(
  rootState: RootState
): { [key: string]: string } {
  const loginForm = rootState[STATE_KEY]
  const errors = {}
  if (loginForm.name === '') {
    errors.name = 'must not be blank'
  }
  if (loginForm.password === '') {
    errors.password = 'must not be blank'
  }
  return errors
}

const initialState: LoginCredentials = {
  name: '',
  password: '',
}

export default function reducer(
  state: LoginCredentials = initialState,
  action: Action
) {
  switch (action.type) {
    case SET_LOGIN_FORM:
      if (action.credentials == null) {
        throw new ActionRequiresPropertyError(SET_LOGIN_FORM, 'credentials')
      } else {
        return action.credentials
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/loginForm.js